import { render, staticRenderFns } from "./btn-text-tertiary.vue?vue&type=template&id=9fbad9f6&scoped=true"
import script from "./btn-text-tertiary.vue?vue&type=script&lang=js"
export * from "./btn-text-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbad9f6",
  null
  
)

export default component.exports